import PortalIdParser from 'PortalIdParser';
const getBaseUrl = () => '/chatspot-widget-ui';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;